import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    Output,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable, of, OperatorFunction } from 'rxjs';
import {
    catchError,
    debounceTime,
    distinctUntilChanged,
    switchMap,
    tap,
} from 'rxjs/operators';
import { hasValidator } from '../_helpers/functions';

@Component({
    selector: 'sume-autocomplete-search',
    templateUrl: './autocomplete-search.component.html',
})
export class AutocompleteSearchComponent {
    model: any;
    searching = false;
    searchFailed = false;
    @Input() label: string;
    @Input() controlName: string;
    @Input() formGroup: FormGroup;
    @Input() items: string[];
    @Input() apiSearch$: (term: string) => Observable<any>;
    @Output() current = new EventEmitter<any>();

    isRequired: boolean;

    constructor(private cdr: ChangeDetectorRef) {}

    ngAfterViewInit(): void {
        if (this.formGroup.controls[this.controlName]?.validator)
            this.isRequired = hasValidator(
                this.formGroup.controls[this.controlName],
                'required'
            );
        this.cdr.detectChanges();
    }

    search: OperatorFunction<string, readonly string[]> = (
        text$: Observable<string>
    ) =>
        text$.pipe(
            debounceTime(300),
            distinctUntilChanged(),
            tap(() => (this.searching = true)),
            switchMap(term =>
                this.apiSearch$(term).pipe(
                    tap(() => (this.searchFailed = false)),
                    catchError(() => {
                        this.searchFailed = true;
                        return of([]);
                    })
                )
            ),
            tap(() => (this.searching = false))
        );

    formatter = (x: { name: string }) => x.name;

    onSelect(value) {
        this.current.next(value.item);
    }
}
